import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=16146b11&scoped=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=js"
export * from "./ArticleDetail.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&id=16146b11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16146b11",
  null
  
)

export default component.exports